import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface PrType {
  active: number;
  createdAt: any;
  name: string;
  description: string;
  code: string;
  selection: string;
  updatedAt: any;
  report: string;
}

export interface PrTypeId extends PrType {
  id: string;
}

@Injectable()
export class ProductTypeService {
  prTypeCollection: AngularFirestoreCollection<PrType>;
  prTypes: any;

  prTypeDocument: AngularFirestoreDocument<PrTypeId>;
  prType: Observable<PrTypeId>;

  collection: string;

  // NOTE: Change this any for PrType Interface
  prType$: Observable<any>;
  prTypes$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router,
  ) {
    this.collection = Globals.PRTYPE_COLLECTION;
  }


  /**
   * Get all prTypes with references
   * @return {Observable} Arrays of prTypes
   */
  getPrCTypes() {
    //return this.afh.colWithIds$(this.collection, ref => ref.orderBy('name'))
    return this.afh.colWithIds$(this.collection, ref => ref.where('selection','==','compra').where('active', '==', true) );
  }
  getPrVTypes() {
    //return this.afh.colWithIds$(this.collection, ref => ref.orderBy('name'))
    return this.afh.colWithIds$(this.collection, ref => ref.where('selection','==','venta').where('active', '==', true) );
  }

  /**
  * Get prType data
  * @param {string} sid - The id of the prType
  * @return {Observable} The PrType Object
  */
  getPrType(sid: string) {
    return this.prType$ = this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Validate if exist
  * @param {PrType} prType - The data of the prType
  */
  codeExistVenta(code: string) {
    return this.afh.colWithIds$(this.collection, ref => {
      return ref.where('code', '==', code).where('selection','==','venta').limit(1)
    });
  }
  codeExistCompra(code: string) {
    return this.afh.colWithIds$(this.collection, ref => {
      return ref.where('code', '==', code).where('selection','==','compra').limit(1)
    });
  }

  /**
  * Create new prType
  * @param {PrType} prType - The data of the prType
  */
  addPrType(prType: PrType) {
    this.afh.add(`${this.collection}`, prType);
    if(prType.selection == 'compra'){
      this.router.navigate(['/prTypeC']);
    }else{
      this.router.navigate(['/prType']);
    }
    
  }

  /**
   * Update current prType
   * @param {string} sid  - The id of the prType
   * @param {PrType} prType - The data of the prType
   */
  updatePrType(sid: string, prType: PrType) {
    this.afh.update(`${this.collection}/${sid}`, prType);
    if(prType.selection == 'compra'){
      this.router.navigate(['/prTypeC']);
    }else{
      this.router.navigate(['/prType']);
    }
  }

  /**
   * Delete current prType
   * @param {string} sid - The id of the prType
   */
  deletePrType(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }
}

export class PrTypeData{
  reports = {
    key0: 'Sin seleccionar',
    key1: 'Principal',
    key2: 'Segundo',
    key3: 'Terceros',
    key4: 'Otros'
  }
}